export const enum SupportArticleSlug {
    TermsOfService = 'terms-of-service',
    PrivacyPolicy = 'privacy-policy',
    RulesOfOperation = 'rules-of-operation',
    ProductsPlacingAndSellingRegulations = 'products-placing-and-selling-regulations',
    ProductsLimitationsPolicy = 'products-limitations-policy',
    BuySellProcess = 'buy-sell-process',
    PaymentRulesBetweenBuyerAndSeller = 'payment-rules-between-buyer-and-seller',
    ProductsConsignationRules = 'products-consignation-rules',
    DisputeResolution = 'dispute-resolution',
    AdvancePaymentBankTransferRepayment = 'advance-payment-bank-transfer-repayment',
}
